// Fakturadetaljer (en).
window.PlummeI18n.register('en', {
  'inv.detail.completion': 'Completion',
  'inv.detail.completed': 'Completed',
  'inv.detail.notCompleted': 'Not completed',
  'inv.detail.paymentStatus': 'Payment status',
  'inv.detail.paid': 'Paid',
  'inv.detail.remaining': 'Remaining',
  'inv.detail.registeredPayments': 'Registered payments',
  'inv.detail.registerPayment': 'Register payment',
  'inv.detail.settlementStatus': 'Settlement',
  'inv.detail.creditOffset': 'Offset',
  'inv.detail.creditRefunded': 'Refunded',
  'inv.detail.creditOpen': 'Not refunded',
  'inv.detail.offsetAgainst': 'Offset against {document}',
  'inv.detail.offsetAgainstInvoice': 'Offset against the invoice',
  'inv.detail.refunded': 'Refunded',
  'inv.detail.toCredit': 'Owed to customer',
  'inv.detail.registeredRefunds': 'Registered refunds',
  'inv.detail.registerRefund': 'Register refund',
  'inv.detail.amountTitle': 'Amount',
  'inv.detail.amountHelp': 'Net, VAT and total are calculated from the saved invoice lines.',
  'inv.detail.net': 'Net',
  'inv.detail.totalAmount': 'Total amount',
  'inv.detail.history': 'History',
  'inv.detail.action': 'Action',
  'inv.detail.loadingDoc': 'Loading document...',
  'inv.detail.openedFromLink': 'Document opened from link',

  'inv.act.open': 'Open',
  'inv.act.openHelp': 'Open the draft in New sale to edit and send it.',
  'inv.act.send': 'Send',
  'inv.act.sendAgain': 'Send again',
  'inv.act.sendCreditNote': 'Send credit note',
  'inv.act.sendHelp': 'Send the document to the customer by email via the backend.',
  'inv.act.markDelivered': 'Mark as delivered',
  'inv.act.markDeliveredHelp': 'Use when the document was delivered to the customer outside Plumme.',
  'inv.act.view.invoice': 'View invoice',
  'inv.act.view.quote': 'View quote',
  'inv.act.view.orderConfirmation': 'View order confirmation',
  'inv.act.view.creditNote': 'View credit note',
  'inv.act.viewHelp': 'Preview the document as the customer sees it.',
  'inv.act.copyLink': 'Copy link',
  'inv.act.copyLinkHelp': 'Copy a shareable link to the document.',
  'inv.act.download': 'Download',
  'inv.act.downloadHelp': 'Download the document as a PDF.',
  'inv.act.packingSlip': 'Create packing slip',
  'inv.act.packingSlipHelp': 'Create and download a packing slip for the goods on this invoice.',
  'inv.act.copy': 'Duplicate',
  'inv.toast.copyOpened': 'The copy is open — save it as a draft or create it',
  'inv.act.share': 'Share',
  'inv.act.shareHelp': 'Copy a sharing link, download the PDF or create a packing slip.',
  'inv.share.title': 'Share the document',
  'inv.act.convertOffer': 'Create',
  'inv.act.convertOfferHelp': 'Creates an invoice or order confirmation as a draft, with the customer and lines from the quote.',
  'inv.convert.title': 'Create from the quote',
  'inv.convert.invoice': 'Invoice',
  'inv.convert.invoiceHelp': 'Normal payment terms. Booked when you create it.',
  'inv.convert.order': 'Order confirmation',
  'inv.convert.orderHelp': 'Confirms the agreement without invoicing. Can be invoiced later.',
  'inv.act.markAccepted': 'Mark as accepted',
  'inv.act.markAcceptedHelp': 'Use this when the customer accepted the quote by phone, in a meeting or by email. Acceptance the customer makes in the quote link is recorded automatically.',
  'inv.act.undoAccepted': 'Remove acceptance',
  'inv.act.undoAcceptedHelp': 'Undoes an acceptance that was recorded here in the app. An acceptance the customer made cannot be removed.',
  'inv.act.copyHelp': 'Create a new invoice with the same content as this one.',
  'inv.act.credit': 'Credit',
  'inv.act.creditHelp': 'Create a credit note that offsets this invoice.',
  'inv.act.delete': 'Delete',
  'inv.act.deleteHelp': 'Delete this draft. This cannot be undone.',

  'inv.err.actionFailed': 'The action could not be completed.',
  'inv.err.openDoc': 'Could not open the document.',
  'inv.err.previewPacking': 'Could not preview the packing slip.',
  'inv.err.settleNotConnected': 'Settling without payment is not connected to the backend.',
  'inv.err.settleFailed': 'Could not settle without payment.',
  'inv.err.needEmail': 'Enter the recipient email first.',
  'inv.err.emailCharset': 'Email addresses cannot contain æ, ø, å or other special characters.',
  'inv.err.invalidEmail': 'This does not look like a valid email address.',
  'inv.err.acceptNotConnected': 'Acceptance is not connected to the backend.',
  'inv.err.acceptFailed': 'Could not update the acceptance.',
  'inv.err.convertNotConnected': 'Conversion is not connected to the backend.',
  'inv.err.convertOpenFailed': 'The draft was created, but could not be opened.',
  'inv.err.convertFailed': 'Could not create the document from the quote.',
  'inv.err.copyOpenFailed': 'The copy was created, but could not be opened.',
  'inv.err.deleteNotConnected': 'Deletion is not connected to the backend.',
  'inv.err.deleteFailed': 'Could not delete the draft.',
  'inv.toast.onlyDrafts': 'Only drafts can be deleted here',
  'inv.toast.offerAccepted': 'The quote is marked as accepted',
  'inv.toast.offerAcceptanceRemoved': 'The acceptance was removed',
  'inv.toast.invoiceDraftFromOffer': 'The invoice is open — save it as a draft or create it',
  'inv.toast.orderDraftFromOffer': 'The order confirmation is open — save it as a draft or create it',
  'inv.toast.draftDeleted': 'Draft deleted',

  'inv.pay.settleWithout': 'Settled without payment',
  'inv.pay.saveChange': 'Save change',
  'inv.pay.paidDate': 'Payment date',
  'inv.pay.datePh': 'dd.mm.yyyy',
  'inv.pay.registerPaymentTitle': 'Register payment',
  'inv.pay.editPaymentTitle': 'Edit payment',
  'inv.pay.registerRefundTitle': 'Register refund',
  'inv.pay.editRefundTitle': 'Edit refund',
  'inv.pay.paidFrom': 'Paid from',
  'inv.pay.refundDate': 'Refund date',
  'inv.pay.refundAmount': 'Refunded amount',
  'inv.pay.remainingNote': 'Remaining on the invoice: {amount}. You can register a part payment.',
  'inv.pay.refundNote': 'The customer is owed {amount} on this credit note. You can register a partial refund.',
  'inv.pay.refundHelp': 'The credit note reverses the sale either way. Only register a refund when the customer actually gets money back.',
  'inv.pay.fee': 'Bank and card fee',
  'inv.pay.feeAccount': 'Fee account',
  'inv.pay.bankAmountIn': 'Actual amount received in the bank: {amount}',
  'inv.pay.bankAmountOut': 'Actual amount paid from the bank: {amount}',
  'inv.detail.offsetCustomerCredit': 'Offset customer credit',
  'inv.detail.customerCreditOffset': 'Customer credit offset',
  'inv.detail.customerCreditAllocated': 'Offset against another invoice',
  'inv.detail.relatedRefund': 'Refunded through the related credit note',
  'inv.toast.customerCreditOffset': 'Customer credit was offset against the invoice',
  'inv.err.noCustomerCredit': 'No available customer credit note was found.',
  'inv.err.customerCreditOffsetFailed': 'Could not offset the customer credit.',
  'cust.ledger.creditOffset': 'Customer credit offset',
  'inv.toast.paymentRegistered': 'Payment registered',
  'inv.toast.paymentUpdated': 'Payment updated',
  'inv.toast.refundRegistered': 'Refund registered',
  'inv.toast.refundUpdated': 'Refund updated',
  'inv.err.paymentFailed': 'Could not register the payment.',
  'inv.err.paymentUpdateFailed': 'Could not update the payment.',
  'inv.err.refundFailed': 'Could not register the refund.',
  'inv.err.refundUpdateFailed': 'Could not update the refund.',

  'inv.del.confirm': 'Yes, delete draft',
  'inv.del.body': 'Are you sure you want to delete this draft for {customer}? This cannot be undone.',
  'inv.send.body': '{document} of {amount} will be sent to {customer} as a PDF by email.',
  'inv.send.resendNote': ' This is a re-send of a document that has already been sent.',

  'inv.credit.continue': 'Continue to credit note',
  'inv.credit.intro': 'A credit note offsets the invoice for {customer}. Choose whether to credit the whole invoice or only part of it.',
  'inv.credit.full': 'Full credit',
  'inv.credit.partial': 'Partial credit',
  'inv.credit.line': 'Line',
  'inv.credit.count': 'Quantity',
  'inv.credit.credited': 'Credited',
  'inv.credit.total': 'Credit note amount',
  'inv.credit.breakdown': 'Net {net} · VAT {vat}',
  'inv.credit.partialSuffix': ' · partial credit',
  'inv.delivery.rowFailed': 'Not delivered',
  'inv.delivery.bannerTitle': '{n} documents did not reach the recipient',
  'inv.delivery.bannerBody': 'The email bounced or was rejected: {documents}. Open the document, correct the customer email address and send it again.',
  'inv.credit.rest': 'Credit the remainder',
  'inv.credit.alreadyCredited': 'Already credited: {amount}. Only the remainder can be credited.',
  'inv.credit.closedLines': '{n} lines are fully credited and are not shown.',
  'inv.credit.lineAlready': 'credited {amount}',
  'inv.credit.hasPayments': 'This invoice has registered payments. The credit note offsets the open amount; any refund is registered separately.',
  'inv.credit.date': 'Credit note date',
  'inv.credit.dateHint': 'The date determines the accounting and VAT period for the credit.',
  'inv.credit.dateBeforeInvoice': 'The credit note date cannot be before the invoice date.',
  'inv.credit.invalidDate': 'Choose a valid credit note date.',
  'inv.credit.paidConfirmTitle': 'The invoice has been paid',
  'inv.credit.paidConfirmBody': 'This invoice has registered payments of {amount}. The credit note reverses the sale, but any refund is registered separately. Do you want to continue?',
  'inv.credit.paidConfirmContinue': 'Yes, continue crediting',
  'inv.bulk.creditDateHint': 'The same date is used for all credit notes. It determines their accounting and VAT period.',
  'inv.bulk.creditDateBeforeInvoices': 'The date cannot be before the latest invoice date in the selection.',
  'inv.bulk.creditPaidConfirmBody': '{n} of the selected invoices have registered payments. The credit notes reverse the sales, but any refunds are registered separately. Do you want to continue?',
  'inv.history.creditPartial': 'Partially credited {amount} · credit note {document}',
  'inv.history.creditFull': 'Credited {amount} · credit note {document}',
  'inv.history.creditDraft': 'Credit note {document} created as a draft · {amount}',
  'inv.history.creditNoNumber': 'no number',
  'inv.toast.creditOpened': 'The credit note for {document} is open — add the reason and create it',
  'inv.toast.partialCreditOpened': 'The partial credit note for {document} is open — add the reason and create it',

  'inv.bulk.selectAll': 'Select everything shown',
  'inv.bulk.selectRow': 'Select document. Shift-click selects the range.',
  'inv.bulk.selectDocument': 'Select document',
  'inv.bulk.selectDocuments': 'Select documents',
  'inv.bulk.selectedCount': '{n} selected',
  'inv.bulk.shownCount': '{n} shown in the list',
  'inv.bulk.reset': 'Clear',
  'inv.bulk.deliver': 'Mark as delivered',
  'inv.bulk.resend': 'Send again',
  'inv.bulk.reminder': 'Dunning notice',
  'inv.bulk.credit': 'Credit',
  'inv.bulk.issue': 'Create and send',
  'inv.bulk.delete': 'Delete',
  'inv.bulk.processing': 'Working ...',
  'inv.bulk.document': 'Document',
  'inv.bulk.amount': 'Amount',
  'inv.bulk.more': '+ {n} more',
  'inv.bulk.noEmail': 'no email',
  'inv.bulk.newDueDate': 'new due date {date}',
  'inv.bulk.reminderType': 'Type',
  'inv.bulk.reminderNotice': 'Payment reminder',
  'inv.bulk.reminderDunning': 'Dunning notice',
  'inv.bulk.reminderDueDays': 'Days until the new due date',
  'inv.bulk.reminderFee': 'Dunning fee',
  'inv.bulk.reminderFeeLocked': 'A fee can only be added on a dunning notice.',
  'inv.bulk.delivery': 'Send as',
  'inv.bulk.deliveryPdf': 'PDF attachment',
  'inv.bulk.deliveryLink': 'Link',
  'inv.bulk.comment': 'Message to the customer',
  'inv.bulk.commentHint': 'Appears in the email next to the amount summary. The invoice itself is unchanged.',
  'inv.bulk.commentPh': 'For example: We can see this invoice is still unpaid. Get in touch if anything is unclear.',
  'inv.comment.label': 'Message to the customer',
  'inv.comment.hint': 'Optional text that goes with this send.',
  'inv.comment.placeholder': 'Write a message ...',
  'inv.comment.useSaved': 'Use a saved message',
  'inv.comment.save': 'Save message',
  'inv.comment.update': 'Update message',
  'inv.comment.saveTitle': 'Save message',
  'inv.comment.updateTitle': 'Update message',
  'inv.comment.saveAsNew': 'Save as new',
  'inv.comment.savedTitle': 'Saved messages',
  'inv.comment.name': 'Message name',
  'inv.comment.namePh': 'For example: Friendly reminder',
  'inv.comment.nameHint': 'The name is how you find the message again in the list.',
  'inv.comment.needName': 'Give the message a name first',
  'inv.comment.empty': 'You have no saved messages yet.',
  'inv.comment.use': 'Use',
  'inv.comment.saved': 'Message saved',
  'inv.comment.updated': 'Message updated',
  'inv.comment.deleted': 'Message deleted',
  'inv.comment.saveFailed': 'Could not save the message.',
  'inv.comment.deleteFailed': 'Could not delete the message.',
  'inv.comment.notConnected': 'Messages are not connected to the backend.',
  'inv.bulk.mode': 'What should happen',
  'inv.bulk.mode.draft': 'Save as drafts',
  'inv.bulk.mode.send': 'Create and send',
  'inv.bulk.mode.create': 'Create only',
  'inv.bulk.mode.hint.credit': 'The credit notes go to the drafts tab. Nothing is posted or sent until you create them.',
  'inv.bulk.mode.hint.creditSend': 'The credit notes are posted and emailed to the customers right away. This cannot be undone.',
  'inv.bulk.mode.hint.issueSend': 'The drafts are posted with a document number and emailed to the customers.',
  'inv.bulk.mode.hint.issue': 'The drafts are posted with a document number, but no email goes out.',
  'inv.bulk.creditReasonOptional': 'Optional while the credit note stays a draft. The reason must be in place before it can be posted.',
  'inv.bulk.creditReasonRequired': 'Required. The reason appears on the credit note and documents why the sale was reversed.',
  'inv.bulk.title.deliver': 'Mark the selected documents as delivered',
  'inv.bulk.title.send': 'Send the selected documents again',
  'inv.bulk.title.reminder': 'Send a dunning notice or payment reminder',
  'inv.bulk.title.credit': 'Credit the selected invoices',
  'inv.bulk.title.issue': 'Create the selected drafts',
  'inv.bulk.title.delete': 'Delete the selected drafts',
  'inv.bulk.confirm.deliver': 'Mark as delivered',
  'inv.bulk.confirm.send': 'Send again',
  'inv.bulk.confirm.reminder': 'Send follow-up',
  'inv.bulk.confirm.credit': 'Create credit notes',
  'inv.bulk.confirm.creditSend': 'Create and send credit notes',
  'inv.bulk.confirm.issue': 'Create the documents',
  'inv.bulk.confirm.issueSend': 'Create and send',
  'inv.bulk.confirm.delete': 'Yes, delete the drafts',
  'inv.bulk.body.deliver': 'Documents that will be marked as delivered outside Plumme: {n}. No email is sent, and accounting and payment are unchanged.',
  'inv.bulk.body.send': '{n} documents will be sent to the email address stored on the customer.',
  'inv.bulk.body.reminder': '{n} overdue or unpaid invoices are followed up. The original invoice is not posted again.',
  'inv.bulk.body.credit': '{n} invoices are credited for the remaining amount, one credit note per invoice. Lines already credited are not included again.',
  'inv.bulk.body.creditSend': '{n} invoices are credited for the remaining amount. The credit notes are created, posted and sent to the customer right away — no detour via drafts.',
  'inv.bulk.body.issue': '{n} drafts are created and posted, and receive a document number.',
  'inv.bulk.body.issueSend': '{n} drafts are created, posted and emailed to the customer.',
  'inv.bulk.body.delete': '{n} drafts will be deleted. Drafts are not posted, but the deletion cannot be undone.',
  'inv.bulk.skip.deliver': 'Selected rows that are drafts, already delivered or sent, and will be skipped: {n}.',
  'inv.bulk.skip.send': '{n} selected documents have no email and are skipped.',
  'inv.bulk.skip.reminder': '{n} selected rows cannot be dunned here or have no email.',
  'inv.bulk.skip.credit': '{n} selected rows cannot be credited here.',
  'inv.bulk.skip.issue': '{n} selected drafts have no customer or no lines, and cannot be created from here.',
  'inv.bulk.skip.noEmail': '{n} of the documents have no email address. They are created and posted, but not sent.',
  'inv.bulk.skip.delete': '{n} selected rows are not drafts and will not be deleted.',
  'inv.bulk.toast.delivered': 'Documents marked as delivered: {n}',
  'inv.bulk.toast.sent': '{n} documents sent',
  'inv.bulk.toast.reminded': '{n} payment reminders sent',
  'inv.bulk.toast.dunned': '{n} dunning notices sent',
  'inv.bulk.toast.credited': '{n} credit notes created as drafts',
  'inv.bulk.toast.creditedSent': '{n} credit notes created and sent',
  'inv.bulk.toast.issued': '{n} documents created',
  'inv.bulk.toast.issuedSent': '{n} documents created and sent',
  'inv.bulk.toast.deleted': '{n} drafts deleted',
  'inv.bulk.toast.notSentSuffix': ', {n} created without an email',
  'inv.bulk.toast.failedSuffix': ', {n} failed',
  'inv.bulk.err.failed': 'Could not complete the bulk action.',
  'inv.bulk.err.deliverNotConnected': 'Mark as delivered is not connected to the backend.',
  'inv.bulk.err.sendNotConnected': 'Sending is not connected to the backend.',
  'inv.bulk.err.creditNotConnected': 'Crediting is not connected to the backend.',
  'inv.bulk.err.issueNotConnected': 'Creating drafts is not connected to the backend.',

  'inv.packing.preview': 'Preview',
  'inv.packing.download': 'Download packing slip',
  'inv.packing.invoiceDate': 'Invoice date',

  'inv.pay.account.1920': 'Operating account - 1920',
  'inv.pay.account.2063': 'Private - 2063',
  'inv.pay.account.1900': 'Cash - 1900',

  'inv.report.customer': 'Customer',
  'inv.report.product': 'Product',
  'inv.report.salesCount': 'Sales',
  'inv.report.count': 'Quantity',
  'inv.report.exVat': 'Excl. VAT',
  'inv.report.share': 'Share of total',
  'inv.report.noSales': 'No sales in the period.',
  'inv.report.noProducts': 'No products sold in the period.',
  'inv.report.openCustomer': 'Open {name} in Customers',
  'inv.report.totalCustomers': '({n} customers)',
  'inv.report.totalCustomer': '({n} customer)',
  'inv.report.totalProducts': '({n} products)',
  'inv.report.totalProduct': '({n} product)',
  'inv.report.total': 'Total',
  'inv.report.tile.sales': 'Sales',
  'inv.report.tile.activeCustomers': 'Active customers',
  'inv.report.tile.newCustomers': 'New customers',
  'inv.report.tile.totalCustomers': 'Customers in total',
  'inv.report.tile.customerRevenue': 'Customer revenue',
  'inv.report.tile.totalRevenue': 'Total revenue',
  'inv.report.tile.soldProducts': 'Products sold',
  'inv.report.tile.productTypes': 'Product types',
  'inv.report.tile.productRevenue': 'Product revenue',
  'inv.report.unknownCustomer': 'Unknown customer',
  'inv.report.unspecifiedSale': 'Unspecified sale',
  'inv.report.customerSummaryOne': '{sales} sales to {customers} customer were recorded during the period. Customer sales amounted to {amount}.',
  'inv.report.customerSummaryMany': '{sales} sales to {customers} customers were recorded during the period. Customer sales amounted to {amount}.',
  'inv.report.productSummaryOne': '{count} products/lines of {types} product type were sold during the period, totaling {amount}.',
  'inv.report.productSummaryMany': '{count} products/lines of {types} product types were sold during the period, totaling {amount}.',
  'inv.fallback.noCustomer': 'No customer',
  'inv.fallback.line': 'Line {n}',
  'inv.credit.fallbackDescription': 'Sale according to {document}',
  'inv.credit.dialogTitle': 'Credit invoice {number}',
  'inv.detail.validUntil': 'Valid until',
  'inv.detail.dueDate': 'Due date',
  'inv.detail.partiallyPaid': 'Partially paid',
  'inv.detail.unpaid': 'Unpaid',
  'inv.detail.acceptedManual': 'Accepted {date} · recorded in the app',
  'inv.detail.acceptedCustomer': 'Accepted {date} · by the customer',
  'inv.detail.orderSentAt': 'Order confirmation sent {date}',
  'inv.detail.paymentFeeBank': 'Fee {fee} · Bank {bank}',
  'inv.detail.deliveryFailureHelp': 'The document is saved, but the recipient did not receive it. Correct the customer email address and send it again.',
  'inv.detail.timelineHelp': 'Timeline built from saved document status and payments.',
  'inv.history.offerAcceptedManual': 'Quote marked as accepted (recorded in the app)',
  'inv.history.offerAcceptedCustomer': 'Quote accepted by the customer',
  'inv.history.orderSent': 'Order confirmation sent',
  'inv.history.documentSentTo': '{document} sent to {recipient}',
  'inv.history.deliveredExternally': 'Delivered outside Plumme',
  'inv.history.documentCreated': 'Document created',
  'inv.packing.intro': 'Set the shipping date. Today is selected by default.',
  'inv.packing.shippingDate': 'Shipping date',
  'inv.packing.contents': 'The packing slip shows descriptions and quantities from the invoice lines. Prices, VAT and payment information are not shown.',
  'inv.packing.title': 'Packing slip {number}',
  'inv.err.pdfPreviewNotConnected': 'PDF preview is not connected to the backend.',
  'inv.err.packingNotConnected': 'Packing slips are not connected to the backend.',
  'inv.err.packingDownloadFailed': 'Could not download the packing slip.',
  'inv.err.paymentNotConnected': 'Payments are not connected to the backend.',
  'inv.err.paymentEditNotConnected': 'Payment editing is not connected to the backend.',
  'inv.err.sendNotConnected': 'Sending is not connected to the backend.',
  'inv.err.sendFailed': 'Could not send the document.',
  'inv.err.deliverNotConnected': 'Mark as delivered is not connected to the backend.',
  'inv.err.deliverFailed': 'Could not mark the document as delivered.',
  'inv.err.linkNotConnected': 'Invoice links are not connected to the backend.',
  'inv.err.linkFailed': 'Could not get the invoice link.',
  'inv.err.downloadNotConnected': 'PDF download is not connected to the backend.',
  'inv.err.downloadFailed': 'Could not download the document.',
  'inv.err.copyNotConnected': 'Copying is not connected to the backend.',
  'inv.err.copyFailed': 'Could not copy the document.',
  'inv.err.archiveNotConnected': 'Archiving is not connected to the backend.',
  'inv.err.archiveFailed': 'Could not update the archive status.',
  'inv.err.creditNotConnected': 'Crediting is not connected to the backend.',
  'inv.err.creditFailed': 'Could not create the credit note.',
  'inv.toast.packingDownloading': 'The packing slip is downloading',
  'inv.toast.settledWithoutPayment': 'The invoice was settled without payment',
  'inv.toast.sendingBackground': '{document} is being sent in the background',
  'inv.toast.documentSent': '{document} sent',
  'inv.toast.deliveredExternally': 'The document was marked as delivered',
  'inv.toast.readyNoEmail': 'The document is ready, but no email was sent.',
  'inv.toast.linkCopied': 'Link to {number} copied',
  'inv.toast.documentDownloading': 'The document is downloading',
  'inv.toast.archiveRestored': 'Restored from archive',
  'inv.toast.archived': 'Archived',
  'inv.toast.creditCreated': '{document} created for {number}',
  'inv.act.unarchive': 'Restore from archive',
  'inv.act.archive': 'Archive',
  'inv.act.archiveHelp': 'Move the quote or order confirmation to the archive, or restore it.',
  'inv.convert.alreadyTitle': 'The quote has already been converted to:',
  'inv.convert.duplicateWarning': 'If you create another document, make sure the customer is not invoiced twice for the same work.',
  'inv.convert.footerHelp': 'Both are created as drafts with the customer and lines from the quote, and open in the sales flow.',
  'inv.send.title': 'Send {document} {number}',
  'inv.deliver.title': 'Mark as delivered',
  'inv.deliver.body': 'Use this when the document has already been delivered to the customer another way. No email is sent from Plumme. Accounting, VAT and payment status are unchanged, while reminders about an unsent document stop.',
  'inv.delivery.external': 'Delivered outside Plumme',
  'inv.more': 'More',
  'inv.err.offerAlreadyConverted': 'The quote has already been converted to this document type.',
  'sale.totalDiscount': 'Total discount',
  'sale.totalDiscountHelp': 'Allocated proportionally across all product lines and stored with a traceable allocation.',

  'sale.det.currency': 'Document currency',
  'sale.det.exchangeRate': 'Rate to {currency}',
  'sale.det.exchangeRateDate': 'Rate date',
  'sale.det.exchangeRateSource': 'Rate source',
  'sale.det.exchangeRateSourcePh': 'For example Norges Bank or an agreed rate',
  'sale.create.needCurrencyEvidence': 'Enter a positive rate, rate date and source before creating the invoice.',
  'sale.preview.accountingAmount': 'Accounting amount: {amount} {currency} · rate {rate}',
  'sale.preview.vatAccountingAmount': 'VAT in {currency}: {amount}',
  'inv.pay.originalAmount': 'Amount in {currency}',
  'inv.pay.bankAmountCurrency': 'Bank amount in {currency}',
  'inv.pay.fxPreview': 'The receivable is settled at {receivable} {accountingCurrency}. The difference from the bank amount is posted as an {kind}: {difference}.',
  'inv.pay.fxGain': 'exchange gain',
  'inv.pay.fxLoss': 'exchange loss',
});
